module.exports = "/_next/static/images/284e9d879e3d582b170a79f5907f56a8-cajita.png.webp";